import { useState } from "react";
import { useSelector } from "react-redux";
import Header from "../componetns/inc/Header";
import TeamCard from "../componetns/ui/TeamCard";
import TeamModal from "../componetns/ui/TeamModal";
import { useGetTeamsQuery } from "../features/team/teamApi";
import Logo from "./../assets/images/logo.png";

export default function Teams() {
    // modal state
    const [isModalOpened, setModalOpened] = useState(false);
    // get user
    const { user } = useSelector((state) => state.auth);
    // get teams api
    const {
        data: getTeams,
        isLoading,
        isError,
    } = useGetTeamsQuery(user?.email);

    // modal close handler
    const closeModal = () => {
        setModalOpened(false);
    };

    // modal open handler
    const modalHandler = () => {
        setModalOpened(true);
    };

    let content;

    if (isLoading && !isError)
        content = <p className="text-green-6000">Loading...</p>;
    if (!isLoading && isError)
        content = <p className="text-red-600">Something wrong</p>;

    if (!isLoading && !isError && getTeams?.length > 0) {
        content = getTeams?.map((team) => (
            <TeamCard key={team.id} team={team} />
        ));
    }
    if (!isLoading && !isError && getTeams?.length === 0) {
        content = <p className="text-red-600">Not created teams!</p>;
    }

    return (
        <>
            <div className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200">
                <Header />
                <div className="px-10 mt-6 flex justify-between">
                    <h1 className="text-2xl font-bold">Teams</h1>

                    <button
                        onClick={modalHandler}
                        className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            ></path>
                        </svg>
                    </button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-10 mt-4 gap-6">
                    {content}
                </div>
            </div>

            <a
                className="fixed bottom-0 right-0 flex items-center justify-center h-8 pl-1 pr-2 mb-6 mr-4 text-blue-100 bg-indigo-600 rounded-full shadow-lg hover:bg-blue-600"
                href="https://learnwithsumit.com"
                target="_blank"
            >
                <div className="flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full">
                    <img src={Logo} alt="LWS Logo" />
                </div>
                <span className="ml-1 text-sm leading-none">
                    Learn with Sumit
                </span>
            </a>
            {isModalOpened && (
                <TeamModal close={closeModal} state={setModalOpened} />
            )}
        </>
    );
}
